export const PRIMARY_COLOR = '#8631A0';
export const SECONDARY_COLOR = '#6B6C7E';
export const BUTTON_COLOR = '#4B7CF3';
export const BLACK_COLOR = '#000000';
export const WHITE_COLOR = '#FFFFFF';
export const GREY_COLOR = {
  GHOSTWHITE: '#F8F8FF',
  LIGHT: '#4A5568',
  DARK: '#6D6767',
  LIGHTER: '#F8F9FE',
  DARK2: '#616161',
  GREY_ICONS: '#6B6C7EB8',
  IN_ACTIVE: '#CFD4E8',
  DARK_INTENSITY_1: '#6B6C7E',
};
export const BODY_BACKGROUND_COLOR = '#E5E5E5';
export const GREEN_COLOR = {
  BRIGHT: '#7DDFC3',
  GREEN: '#008000',
  LIGHT: '#eafaf6',
  LIGHT_OPACITY: 'rgba(125, 223, 195, 0.03)',
  DARK: '#319d6f',
};
export const BLUE_COLOR = {
  LIGHT: '#eceffc',
  LIGHT1: '#d3daf8',
  DARK: '#2b6f8a',
};
export const SUCCESS_COLOR = '#7DDFC3';
export const GREY_TEXT_COLOR = '#696868';
export const BOX_BACKGROUND_COLOR = '#F5F7FF';
export const ERROR_COLOR = '#FF8B7B';
export const CAPTION_COLOR = '#8B8FA1';
export const TAGS_COLOR = '#A2AAD0';
export const PLANS_BACKGROUND = {
  CURRENT_PLAN: '#ECEFFC8C',
};

export const FOOTER_COLOR = '#A2A3A5';
export const RED_COLOR = {
  DARK: '#a54747',
};
